/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Merge_Event_TitleInputs */

const en_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Event`)
};

const fr_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner l'evenement`)
};

const de_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführungsereignis`)
};

const it_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci evento`)
};

const ru_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие слияния`)
};

const es_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento de fusión`)
};

const zh_cn2_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并事件`)
};

const ja_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マージイベント`)
};

const hi_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलय कार्यक्रम`)
};

const pt_pt2_timeline_merge_event_title = /** @type {(inputs: Timeline_Merge_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento de Fusão`)
};

/**
* | output |
* | --- |
* | "Merge Event" |
*
* @param {Timeline_Merge_Event_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_merge_event_title = /** @type {((inputs?: Timeline_Merge_Event_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Merge_Event_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_merge_event_title(inputs)
	if (locale === "de") return de_timeline_merge_event_title(inputs)
	if (locale === "it") return it_timeline_merge_event_title(inputs)
	if (locale === "ru") return ru_timeline_merge_event_title(inputs)
	if (locale === "es") return es_timeline_merge_event_title(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_merge_event_title(inputs)
	if (locale === "ja") return ja_timeline_merge_event_title(inputs)
	if (locale === "hi") return hi_timeline_merge_event_title(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_merge_event_title(inputs)
	return en_timeline_merge_event_title(inputs)
});